module.exports = __webpack_public_path__ + "img/idcard_positive.dca8003b.png";